/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 11:26:46
 * @Description: 
 */
import React from "react";
import { CanvasLoadingLarger } from "src/assets";
import { useCurrentEffect } from "src/hooks";
import EffectListCollapseItem from "../ToolLeftEffectList/EffectListCollapseItem/EffectListCollapseItem";
import ToolLeftNoSearchList from "./ToolLeftNoSearchList"
import "./ToolLeftSearchList.scss"
interface Iprops {
  searchList: any[]
}
export default function ToolLeftSearchList(props: Iprops) {
  let { searchList } = props
  let currentEffect = useCurrentEffect()
  let newEffectList = []
  let [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [searchList])
  for(let i = 0; i < searchList.length; i += 3) {
    newEffectList.push(searchList.slice(i, i + 3))
  }
  if(loading) {
    return <div className="search_list_loading">
      <img src={CanvasLoadingLarger} alt="" />
    </div>
  }
  return <div className="search_list">
    {newEffectList.length > 0 && <div className="search_list_numbers">
      {searchList.length} Results
    </div>}
    {
      newEffectList.length > 0 ? newEffectList.map((item, index) => {
        return <div key={index}>
          {
            item.map((ite: any) => {
              return <EffectListCollapseItem needCollapse={true} key={ite.name}  effect={ite} active={currentEffect === ite} />
            })
          }
        </div>
      }) : <ToolLeftNoSearchList />
    }
  </div>
}